export var configInitialState = {
    messages: {
        resourcesInfo: '',
        uploadFileInfo: '',
        uploadUrlInfo: '',
    },
    autoSaveTimeOut: null,
    locationResponseTime: null,
};
